export default __webpack_public_path__ + "5b9006a11d21450b4eeca716e0c0e5e6.png";